var moment = require('moment');
var React = require('react');
var robot = require('../images/error-robot-2.png');

var Error = React.createClass({
    render: function () {
        return <div className="standalone-page-wrapper">
            <div className="error-top-block">
              <div className="error-top-block-image"> <img src={robot} alt="Ooops!" /> </div>
            </div>

            <div className="error-bottom-block">
              <div className="col-md-6 col-md-offset-3 error-description">
                <div className="error-code">Uhoh</div>
                <div className="error-meaning">Your browser is too old.</div>
                <div className="todo">
                  <h4>The browser you're using is out of date and no longer supported.</h4>
                  <p>
                      Our portal uses technology not available in your browser and we are
                      unable to support it. For a better browsing experience on the internet
                      please visit <a href="http://browsehappy.com">browsehappy.com</a> for
                      more information on upgrading your browser.
                  </p>
                </div>
                <div className="copyrights"> &copy; Infinite Networks Pty Ltd {moment().format('YYYY')}</div>
              </div>
            </div>
        </div>;
    }
})
module.exports = Error;



// WEBPACK FOOTER //
// ./app/components/Unsupported.js